import { SnLocation } from '@lib/api/entities';
import { MultiPolygonOverlay } from '@lib/geo/google/map';

export class SnLocationPolygon extends MultiPolygonOverlay {
  constructor(public readonly location: SnLocation) {
    super(
      {
        id: `location-${location.id}-polygon`,
      },
      location.geofence,
    );
  }
}
